<form #form="ngForm" novalidate
    class="form-wizard-step"
    [class.novo-lead]="novoLead">
    
    <!-- Novo Lead -->
    <ng-template [ngIf]="novoLead">
        <div class="form-wizard-step-header">
            <h4 class="form-wizard-step-title">
                Lead
            </h4>
            <p class="form-wizard-step-text">
                Informe os dados do novo lead a ser qualificado.           
            </p>
        </div>

        <div class="form-wizard-step-content no-padding">
            <sgt-lead-form-container
                #leadForm
                [isGetIDParam]="false"
                [isShowOptions]="false"
                (afterCancel)="cancel.emit()">
            </sgt-lead-form-container>        
        </div>
        
        <div class="form-wizard-step-actions">
            <div>
                <button type="button" class="btn btn-sm btn-light mr-2" (click)="previus.emit()" *ngIf="!isFirstStep">
                    <i class="fas fa-arrow-left"></i> Voltar
                </button>            
                <button type="button" class="btn btn-sm btn-link" (click)="selectLead()">
                    <i class="fas fa-hand-pointer"></i> Selecionar Lead
                </button>
            </div>
            
            <button type="button" class="btn btn-sm btn-primary" (click)="nextClick()" [disabled]="leadForm?.invalid">
                Avançar <i class="fas fa-arrow-right"></i>
            </button>
        </div>        
    </ng-template>

    <!-- Lead Existente -->
    <ng-template [ngIf]="!novoLead">
        <div class="form-wizard-step-header">
            <h4 class="form-wizard-step-title">
                Lead
            </h4>
            <p class="form-wizard-step-text">
                Selecione o lead a ser qualificado.               
            </p>
        </div>

        <div class="form-wizard-step-content">
            <div class="row">
                <div class="form-group col-12">
                    <label for="lead" class="col-form-label">Lead</label>
                    <sgt-lead-typeahead [(ngModel)]="leadSearch" name="lead" id="lead"
                        #leadTypeaead #leadModel="ngModel" 
                        [ngControl]="leadModel" 
                        [autofocus]="true"
                        [required]="true"
                        [createWhenNoResults]="true"
                        (create)="createLead($event)"
                        (entitySelected)="onSelected($event)"
                        (clearEntity)="onClear()">
                    </sgt-lead-typeahead>
                    <sgt-form-control-error
                        *ngIf="leadModel.errors && leadModel.errors.required && leadModel.dirty"
                        msgError="O lead é obrigatório">
                    </sgt-form-control-error>                      
                </div>
            </div>
        </div>
        
        <div class="form-wizard-step-actions">
            <div>
                <button type="button" class="btn btn-sm btn-light mr-2" (click)="previus.emit()" *ngIf="!isFirstStep">
                    <i class="fas fa-arrow-left"></i> Voltar
                </button>
                <button type="button" class="btn btn-sm btn-link" (click)="createLead(null)">
                    <i class="fas fa-plus"></i> Cadastrar Novo Lead
                </button>                
            </div>
            
            <button type="button" class="btn btn-sm btn-primary" (click)="nextClick()" [disabled]="form.invalid">
                Avançar <i class="fas fa-arrow-right"></i>
            </button>
        </div>        
    </ng-template>    
</form>